/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { useRequest } from 'ahooks';
import dayjs from 'dayjs';
import useGo from '@utils/navigate';
import BasePage from '@src/basePage';
import { PAGE_NAME, LX_PERSONAL_CENTER_VIEW } from '@common/const';
import { Loading, Button, Pagination, Icon } from '@ss/mtd-react';
import { getDeliveryList } from '@service/index';
import classNames from 'classnames';
import NoData from '@elements/NoData';
import { scrollToTop } from '@utils/dom';
import { LxPageView } from '@utils/siteLx';
import { IDeliveryItem } from '@src/types';
import DeliveryRecordItem from './deliveryRecordItem';
import CampusApplyRecord from './campusApplyRecord';
import './index.scss';

function DeliveryRecord() {
  const { go } = useGo();
  const [listData, setListData] = useState<IDeliveryItem[]>([]);
  const [oldListData, setOldListData] = useState<IDeliveryItem[]>([]);
  const [page, setPage] = useState({
    pageNo: 1,
    pageSize: 10,
  });
  const [totalCount, setTotalCount] = useState(0);
  const [isFold, setIsFold] = useState<boolean>(true);
  const { loading, runAsync: runRequestList } = useRequest(getDeliveryList, { throttleWait: 1000, manual: true });
  useEffect(() => {
    (async () => {
      const { page: _page, applyRecords } = await runRequestList({ pageNo: page.pageNo, pageSize: page.pageSize });
      const newApplyRecords: IDeliveryItem[] = [];
      const oldApplyRecords: IDeliveryItem[] = [];
      try {
        applyRecords?.forEach((it: IDeliveryItem) => {
          if (it.deliverTime && it.deliverTime.replace(/-/g, '/')) {
            const deliverTimeNum = new Date(it.deliverTime).getTime();
            it.deliverTimeNum = deliverTimeNum || 0;
          }
          // 2023/01/01 00:00:00
          if (it && it.deliverTimeNum && it.deliverTimeNum > 1672502400000) {
            newApplyRecords.push(it);
          } else {
            oldApplyRecords.push(it);
          }
        });
      } catch (error) {
        setListData(applyRecords || []);
        console.error(error);
      }
      setListData(newApplyRecords);
      setOldListData(oldApplyRecords);
      setTotalCount(_page?.totalCount);
      setIsFold(newApplyRecords.length !== 0);
    })();
  }, [page.pageNo]);
  useEffect(() => {
    // pageId
    LxPageView({ cid: LX_PERSONAL_CENTER_VIEW.deliveryRecord });
  }, []);
  const handleChange = async (current) => {
    setPage({ ...page, pageNo: current });
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const renderDom = () => {
    if (loading) {
      return (
        <div className="loading">
          <Loading direction="vertical" message="加载中" size="large" />
        </div>
      );
    }
    if (
      (!listData && !oldListData) ||
      (Array.isArray(listData) && listData.length === 0 && Array.isArray(oldListData) && oldListData.length === 0)
    ) {
      return (
        <NoData text="你当前还没有投递过职位">
          <Button
            size="large"
            className="delivery_btn"
            onClick={() => {
              go('/position');
              scrollToTop();
            }}
          >
            去投递
          </Button>
        </NoData>
      );
    }
    return (
      <>
        {dayjs().isBefore('2024-10-11', 'day') && (
          <div className="delivery_record_org_adjustment_tips">
            <Icon type="warning-circle" style={{ fontSize: 20, color: '#166FF7' }} />
            <span>由于美团组织架构调整，部分志愿的意向部门会出现重复，请放心，该调整不会影响你接下来的求职进展。</span>
          </div>
        )}
        {listData.map((item, index) => {
          if (item && item.volunteerRecord) {
            return <CampusApplyRecord key={index} volunteerSchedule={item.volunteerRecord} />;
          }
          return <DeliveryRecordItem recordInfo={item?.generalRecord} key={item?.generalRecord?.applyJobId} />;
        })}
        <div className={classNames({ hide: oldListData.length === 0 })}>
          <div
            className="recordFoldWrap cursor_pointer"
            onClick={() => {
              setIsFold(!isFold);
            }}
          >
            {/* {isFold ? '历史投递记录' : '历史投递记录'} */}
            历史投递记录
            <span className={classNames('iconWrap', { iconWrap180: !isFold })}>
              <Icon type="triangle-down" style={{ fontSize: 24 }} />
            </span>
          </div>
        </div>
        <div className={classNames({ hide: isFold })}>
          {oldListData.map((item, index) => {
            if (item && item.volunteerRecord) {
              return <CampusApplyRecord key={index} volunteerSchedule={item.volunteerRecord} />;
            }
            return <DeliveryRecordItem recordInfo={item?.generalRecord} key={item?.generalRecord?.applyJobId} />;
          })}
        </div>
        <div className="common_pagination" style={{ textAlign: 'right' }}>
          <Pagination
            size="small"
            bordered={false}
            pageSize={page.pageSize}
            current={page.pageNo}
            total={totalCount}
            onChange={handleChange}
          />
        </div>
      </>
    );
  };
  return <div className="delivery_record">{renderDom()}</div>;
}

export default BasePage(DeliveryRecord, PAGE_NAME.resumeDetail);
